export default __webpack_public_path__ + "static/media/flexicuiot.c0335003.jpeg";